import React from 'react';
import { Card, CardContent, Box, Typography, Skeleton } from '@mui/material';

export default function StatCard({ title, value, subtitle, icon, color = '#00BFA5', loading, trend, small }) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: small ? 2 : 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1 }}>
          <Typography variant="caption" color="text.secondary" fontFamily='"IBM Plex Mono", monospace'
            sx={{ textTransform: 'uppercase', letterSpacing: '0.08em', fontSize: '0.68rem', lineHeight: 1.4 }}>
            {title}
          </Typography>
          {icon && (
            <Box sx={{ color, opacity: 0.7, display: 'flex', alignItems: 'center', ml: 1 }}>
              {icon}
            </Box>
          )}
        </Box>

        {loading ? (
          <Skeleton variant="text" width="60%" height={40} />
        ) : (
          <Typography variant={small ? 'h5' : 'h4'} fontWeight={700} color={color}
            fontFamily='"IBM Plex Mono", monospace' lineHeight={1}>
            {value}
          </Typography>
        )}

        {subtitle && (
          <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
            {subtitle}
          </Typography>
        )}
        {trend !== undefined && (
          <Typography variant="caption" sx={{ color: trend >= 0 ? '#69F0AE' : '#FF5252', fontFamily: '"IBM Plex Mono", monospace', fontSize: '0.72rem' }}>
            {trend >= 0 ? '▲' : '▼'} {Math.abs(trend)}% vs last month
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
